/**
 * removePadding
 * @param {string} value base64 string 
 * @returns base64 string without padding
 */
const removePadding = (value) => {
	return value.replace(/=+$/, '')
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
}

/**
 * addPadding
 * @param {string} base64 (without padding) 
 * @returns base64 string with re-added padding
 */
const addPadding = (value) => {
	if (value.length % 4 === 2) {
		value += "==";
	}
 
	if (value.length % 4 === 3) {
		value += "=";
	}

	value = value.replaceAll('-', '+');
	value = value.replaceAll('_', '/');

	return value;
}

export { removePadding, addPadding };